import { WalletTransferStepStatus } from '../../../transfer-history/wallet-transfer-history.model';

/**
 * The whole class list each stop is drawn with, layout included: the sheet binds `[class]`
 * to one of these outright, the way it must — a static `class` beside a `[class]` binding
 * is the same attribute twice, and the template linter refuses it.
 */
const STEP_CIRCLE = 'z-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full';
const STEP_TITLE = 'text-3';

/** The circle a stop carries: a check behind, a ring on the one the money waits on. */
export const DEPOSIT_PAYMENT_RESULT_CIRCLE_CLASSES: Record<WalletTransferStepStatus, string> = {
	done: `${STEP_CIRCLE} bg-blue-700 text-white`,
	current: `${STEP_CIRCLE} border border-blue-700 bg-gray-000`,
	failed: `${STEP_CIRCLE} bg-red-500 text-white`,
	upcoming: `${STEP_CIRCLE} border border-gray-300 bg-gray-000`
};

/** The stop the money lands in the wallet on, which the handoff draws green. */
export const DEPOSIT_PAYMENT_RESULT_ARRIVED_CIRCLE = `${STEP_CIRCLE} bg-green-500 text-white`;

/** How a stop's title reads: dark while it is still to come, red once it has stopped there. */
export const DEPOSIT_PAYMENT_RESULT_TITLE_CLASSES: Record<WalletTransferStepStatus, string> = {
	done: `${STEP_TITLE} text-gray-900`,
	current: `${STEP_TITLE} text-gray-900`,
	failed: `${STEP_TITLE} text-red-500`,
	upcoming: `${STEP_TITLE} text-gray-500`
};

/** The two stops of a gateway deposit that name no wallet, in the handoff's own words. */
export const DEPOSIT_PAYMENT_RESULT_STEPS = {
	gateway: 'درگاه بانکی',
	confirm: 'تأیید پرداخت بانکی'
} as const;

/**
 * Where a gateway deposit's amount and target wallet wait while the browser is at the bank:
 * the callback carries neither, and the result sheet names both.
 */
export const DEPOSIT_PENDING_PAYMENT_KEY = 'kala-wallet-pending-payment';
